export type MentorWorkspaceId = "teens" | "support";

export interface MentorWorkspaceOption {
  id: MentorWorkspaceId;
  label: string;
}

export const MENTOR_WORKSPACES: MentorWorkspaceOption[] = [
  { id: "teens", label: "Teens" },
  { id: "support", label: "Support" },
];

export const DEFAULT_MENTOR_WORKSPACE: MentorWorkspaceId = "teens";

const WORKSPACE_STORAGE_KEY = "mentor-workspace";

export function isMentorWorkspace(value: unknown): value is MentorWorkspaceId {
  return value === "teens" || value === "support";
}

export function readStoredMentorWorkspace(): MentorWorkspaceId | null {
  try {
    const stored = sessionStorage.getItem(WORKSPACE_STORAGE_KEY);
    return isMentorWorkspace(stored) ? stored : null;
  } catch {
    return null;
  }
}

export function storeMentorWorkspace(workspace: MentorWorkspaceId): void {
  try {
    sessionStorage.setItem(WORKSPACE_STORAGE_KEY, workspace);
  } catch {
    // Session storage is unavailable; sticky selection is best-effort.
  }
}

export function resolveMentorWorkspace(
  searchSegment: unknown,
  storedWorkspace: MentorWorkspaceId | null,
): MentorWorkspaceId {
  if (isMentorWorkspace(searchSegment)) return searchSegment;
  return storedWorkspace ?? DEFAULT_MENTOR_WORKSPACE;
}

export function getMentorWorkspaceLabel(workspace: MentorWorkspaceId): string {
  return (
    MENTOR_WORKSPACES.find((option) => option.id === workspace)?.label ??
    workspace
  );
}
